/* Breadcrumbs.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ul9idpf%7Bmin-width%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._6rth1b66%7Bmargin-block-end%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._nd5l10tg%7Bgrid-area%3Abreadcrumbs%7D");
import React from 'react';
import Box from '@atlaskit/primitives/box';
import { Box as CompiledBox } from '@atlaskit/primitives/compiled';
// eslint-disable-next-line @townsquare/rules/no-xcss
import { xcss } from '@atlaskit/primitives/xcss';
import { fg } from '@townsquare/stat-sig/gate';
const styles = xcss({
  gridArea: 'breadcrumbs',
  marginBlockEnd: 'space.050',
  minWidth: '0'
});
const compiledStyles = {
  root: "_nd5l10tg _6rth1b66 _1ul9idpf"
};
export const Breadcrumbs = ({
  children
}: React.PropsWithChildren<unknown>): React.JSX.Element => {
  return fg('townsquare-compiled-xcss-to-cssmap') ? <CompiledBox xcss={compiledStyles.root}>{children}</CompiledBox> : <Box xcss={styles}>{children}</Box>;
};